import { render, staticRenderFns } from "./TestersPhones.vue?vue&type=template&id=17617806&scoped=true&"
import script from "./TestersPhones.vue?vue&type=script&lang=js&"
export * from "./TestersPhones.vue?vue&type=script&lang=js&"
import style0 from "./TestersPhones.vue?vue&type=style&index=0&id=17617806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17617806",
  null
  
)

export default component.exports